export default __webpack_public_path__ + "static/media/lookingBox.7401d214.png";